module.exports = new __parcel__URL__("appdevelopment.c70aea04.png").toString();